import React, { useState } from "react";
import Image from "next/image";
import Certifications from "@components/Security/Certifications";

const BasicChip = ({ icon, text, images }) => {
  return (
    <div className="w-[280px] px-3 py-4 flex items-center justify-between gap-3 bg-white rounded-lg  moveUpObject">
      {icon && (
        <div className="bg-orange-400 w-[50px] h-[50px] rounded-full flex justify-center items-center text-3xl text-gray-700">
          {icon}
        </div>
      )}
      {text && <p className="text-sm flex-1 text-gray-800">{text}</p>}
      {images && (
        <div className="mx-auto">
          <Certifications displayText={true} certifications={images} customStyling="w-full gap-4" />
        </div>
      )}
    </div>
  );
};

const ChipWithImage = ({ image, title, description }) => {
  return (
    <div className="w-[340px] px-4 py-6 flex items-center justify-between gap-3 bg-white rounded-lg border border-gray-800">
      <div className="bg-gray-100 w-[80px] h-[80px] rounded-lg flex justify-center items-center">
        <Image
          src={require("@assets/marquee/" + image)}
          alt={title}
          width={50}
          height={50}
          className="w-full p-2 removeBg"
        />
      </div>
      <div className="flex-1 flex flex-col gap-1">
        <h4 className="text-2xl">{title}</h4>
        <p className="text-sm flex-1 text-gray-800">{description}</p>
      </div>
    </div>
  );
};

const MiniNavbar = ({ navItems }) => {
  return (
    <div className="flex flex-wrap justify-center items-center gap-y-2 gap-x-4 sm:gap-16 border border-gray-600 py-4 rounded-full">
      {navItems.map((item, index) => {
        return (
          <div
            key={index}
            className={`text-md sm:text-xl flex items-center gap-2 cursor-pointer ${
              item.active ? "text-violet-500" : "text-gray-800"
            }`}
          >
            {item.text}
          </div>
        );
      })}
    </div>
  );
};

const Switch = ({ switch1, switch2, onChangeTab }) => {
  const [isChecked, setIsChecked] = useState(true);

  const handleToggle = () => {
    setIsChecked(!isChecked);
    onChangeTab();
  };
  return (
    <div className="flex items-center gap-4 text-lg sm:text-xl">
      {switch1 && <div className="">{switch1}</div>}
      <div
        className={`w-16 h-8 flex items-center bg-black rounded-full p-1 cursor-pointer transition-colors duration-300 ${
          isChecked ? "bg-black" : "bg-black"
        }`}
        onClick={handleToggle}
      >
        <div
          className={`bg-white w-6 h-6 rounded-full shadow-md transform transition-transform duration-300 ${
            isChecked ? "translate-x-8" : "translate-x-0"
          }`}
        ></div>
      </div>
      {switch2 && <div className="">{switch2}</div>}
    </div>
  );
};

module.exports = {
  BasicChip,
  MiniNavbar,
  ChipWithImage,
  Switch,
};
